import axios from 'axios';

export default axios.create({
    baseURL : process.env.VUE_APP_URL_AXIOS,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('token_street_shopping'),
        'Api-Key': process.env.VUE_APP_API_KEY
    }
});